import React from "react";
import {
  TextField,
  Box,
  Grid2
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {
  basketTypeOptions,
  basketSizeOptions,
  basketLinerOptions,
  basketLinerSizeOptions,
} from "../constants/closetOptions";
export const createEmptyBasketRow = () => ({
  basketquantity: "",
  baskettype: "",
  basketsize: "",
  basketliner: "",
  basketlinersize: "",
});

export default function BasketRowFields({ row, index, onFieldChange, fieldErrors = {} }) {
  const { basketquantity, baskettype, basketsize, basketliner, basketlinersize } = row;

  const sizeList = baskettype ? basketSizeOptions[baskettype] || [] : [];
  const linerList = baskettype && basketsize ? basketLinerOptions[baskettype] || [] : [];
  const linerSizeList =
    basketliner && basketliner !== "No Liner" ? basketLinerSizeOptions[basketliner] || [] : [];

  const hasError = (field) => !!fieldErrors[`${index}-${field}`];

  return (
    <>
      {/* Row 1: Quantity + Basket Type */}
      <Grid2 container spacing={2} sx={{ mt: 1 }}>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Basket Quantity"
            type="text"
            value={basketquantity || ""}
            error={hasError("basketquantity")}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "" || /^[1-9]\d*$/.test(value)) {
                onFieldChange(index, { basketquantity: value });
              }
            }}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Autocomplete
            options={basketTypeOptions}
            value={basketTypeOptions.includes(baskettype) ? baskettype : null}
            onChange={(_, v) =>
              // Changing the type invalidates size/liner/liner-size picked
              // for the previous type, so reset them atomically.
              onFieldChange(index, {
                baskettype: v || "",
                basketsize: "",
                basketliner: "",
                basketlinersize: "",
              })
            }
            renderInput={(params) => (
              <TextField {...params} label="Basket Type" error={hasError("baskettype")} />
            )}
          />
        </Grid2>
      </Grid2>

      {/* Row 2: Basket Size + Basket Liner */}
      <Grid2 container spacing={2} sx={{ mt: 3 }}>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          {baskettype && sizeList.length > 0 ? (
            <Autocomplete
              options={sizeList}
              value={sizeList.includes(basketsize) ? basketsize : null}
              onChange={(_, v) =>
                onFieldChange(index, { basketsize: v || "", basketliner: "", basketlinersize: "" })
              }
              renderInput={(params) => (
                <TextField {...params} label="Basket Size (W-D-H)" error={hasError("basketsize")} />
              )}
            />
          ) : (
            <Box sx={{ height: "100%" }} />
          )}
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 6 }}>
          {baskettype && basketsize && linerList.length > 0 ? (
            <Autocomplete
              options={linerList}
              value={linerList.includes(basketliner) ? basketliner : null}
              onChange={(_, v) =>
                onFieldChange(index, {
                  basketliner: v || "",
                  basketlinersize: v === "No Liner" ? "" : basketlinersize,
                })
              }
              renderInput={(params) => (
                <TextField {...params} label="Basket Liner" error={hasError("basketliner")} />
              )}
            />
          ) : (
            <Box sx={{ height: "100%" }} />
          )}
        </Grid2>
      </Grid2>

      {/* Row 3: Liner Size */}
      <Grid2 container spacing={2} sx={{ mt: 3 }}>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          {basketliner && basketliner !== "No Liner" && linerSizeList.length > 0 ? (
            <Autocomplete
              options={linerSizeList}
              value={linerSizeList.includes(basketlinersize) ? basketlinersize : null}
              onChange={(_, v) => onFieldChange(index, { basketlinersize: v || "" })}
              renderInput={(params) => (
                <TextField {...params} label="Liner Size (W-D-H)" error={hasError("basketlinersize")} />
              )}
            />
          ) : (
            <Box sx={{ height: "100%" }} />
          )}
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }} />
      </Grid2>
    </>
  );
}